import { render, staticRenderFns } from "./selectInstitution.vue?vue&type=template&id=f78e346a&"
import script from "./selectInstitution.vue?vue&type=script&lang=js&"
export * from "./selectInstitution.vue?vue&type=script&lang=js&"
import style0 from "./selectInstitution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports